var _CUSTOM_COD_FORM_PROVINCES = {
  data: {
    "Baja California": {
      "Tijuana": {
        "22000": true,
        "22010": true,
        "22014": true,
        "22015": true,
        "22020": true,
        "22024": true,
        "22025": true,
        "22030": true,
        "22034": true,
        "22035": true,
        "22040": true,
        "22044": true,
        "22045": true,
        "22046": true,
        "22050": true,
        "22054": true,
        "22055": true,
        "22056": true,
        "22100": true,
        "22104": true,
        "22105": true,
        "22106": true,
        "22110": true,
        "22114": true,
        "22115": true,
        "22116": true,
        "22117": true,
        "22120": true,
        "22123": true,
        "22124": true,
        "22125": true,
        "22126": true,
        "22127": true,
        "22160": true,
        "22163": true,
        "22164": true,
        "22170": true,
        "22180": true,
        "22183": true,
        "22185": true,
        "22186": true,
        "22190": true,
        "22194": true,
        "22195": true,
        "22196": true,
        "22200": true,
        "22203": true,
        "22204": true,
        "22205": true,
        "22206": true,
        "22207": true,
        "22210": true,
        "22214": true,
        "22215": true,
        "22216": true,
        "22217": true,
        "22220": true,
        "22223": true,
        "22224": true,
        "22225": true,
        "22226": true,
        "22230": true,
        "22234": true,
        "22235": true,
        "22236": true,
        "22237": true,
        "22244": true,
        "22245": true,
        "22246": true,
        "22250": true,
        "22253": true,
        "22254": true,
        "22333": true,
        "22400": true,
        "22404": true,
        "22405": true,
        "22406": true,
        "22410": true,
        "22414": true,
        "22415": true,
        "22416": true,
        "22420": true,
        "22424": true,
        "22425": true,
        "22426": true,
        "22427": true,
        "22430": true,
        "22434": true,
        "22435": true,
        "22436": true,
        "22439": true,
        "22440": true,
        "22444": true,
        "22446": true,
        "22450": true,
        "22454": true,
        "22455": true,
        "22456": true,
        "22457": true,
        "22460": true,
        "22464": true,
        "22465": true,
        "22470": true,
        "22473": true,
        "22474": true,
        "22476": true,
        "22500": true,
        "22504": true,
        "22505": true,
        "22506": true,
        "22510": true,
        "22515": true,
        "22516": true,
        "22517": true,
        "22520": true,
        "22523": true,
        "22524": true,
        "22525": true,
        "22526": true,
        "22530": true,
        "22534": true,
        "22535": true,
        "22536": true,
        "22537": true,
        "22540": true,
        "22544": true,
        "22545": true,
        "22550": true,
        "22555": true,
        "22557": true,
        "22560": true,
        "22564": true,
        "22565": true,
        "22566": true,
        "22567": true,
        "22600": true,
        "22604": true,
        "22605": true,
        "22606": true,
        "22607": true,
        "22610": true,
        "22614": true,
        "22615": true,
        "22616": true,
        "22620": true,
        "22624": true,
        "22625": true,
        "22626": true,
        "22630": true,
        "22634": true,
        "22635": true,
        "22636": true,
        "22637": true,
        "22640": true,
        "22643": true,
        "22644": true,
        "22645": true,
        "22646": true,
        "22647": true,
        "22650": true,
        "22654": true,
        "22660": true,
        "22663": true,
        "22664": true,
        "22665": true,
        "22666": true,
        "22667": true
      }
    },
    "Ciudad de México": {
      "Azcapotzalco": {
        "02000": true,
        "02010": true,
        "02020": true,
        "02040": true,
        "02050": true,
        "02060": true,
        "02070": true,
        "02080": true,
        "02090": true,
        "02099": true,
        "02100": true,
        "02120": true,
        "02128": true,
        "02129": true,
        "02130": true,
        "02140": true,
        "02150": true,
        "02160": true,
        "02200": true,
        "02230": true,
        "02240": true,
        "02250": true,
        "02300": true,
        "02310": true,
        "02320": true,
        "02330": true,
        "02340": true,
        "02360": true,
        "02400": true,
        "02410": true,
        "02420": true,
        "02440": true,
        "02459": true,
        "02460": true,
        "02470": true,
        "02480": true,
        "02490": true,
        "02500": true,
        "02519": true,
        "02520": true,
        "02530": true,
        "02600": true,
        "02630": true,
        "02640": true,
        "02650": true,
        "02660": true,
        "02670": true,
        "02680": true,
        "02700": true,
        "02710": true,
        "02719": true,
        "02720": true,
        "02730": true,
        "02750": true,
        "02760": true,
        "02770": true,
        "02780": true,
        "02790": true,
        "02800": true,
        "02810": true,
        "02830": true,
        "02840": true,
        "02860": true,
        "02870": true,
        "02900": true,
        "02910": true,
        "02920": true,
        "02930": true,
        "02940": true,
        "02950": true,
        "02960": true,
        "02970": true,
        "02980": true,
        "02990": true
      },
      "Benito Juárez": {
        "03000": true,
        "03010": true,
        "03020": true,
        "03023": true,
        "03100": true,
        "03103": true,
        "03104": true,
        "03200": true,
        "03230": true,
        "03240": true,
        "03300": true,
        "03303": true,
        "03310": true,
        "03320": true,
        "03330": true,
        "03340": true,
        "03400": true,
        "03410": true,
        "03420": true,
        "03430": true,
        "03440": true,
        "03500": true,
        "03510": true,
        "03520": true,
        "03530": true,
        "03540": true,
        "03550": true,
        "03560": true,
        "03570": true,
        "03580": true,
        "03590": true,
        "03600": true,
        "03610": true,
        "03620": true,
        "03630": true,
        "03640": true,
        "03650": true,
        "03660": true,
        "03700": true,
        "03710": true,
        "03720": true,
        "03730": true,
        "03740": true,
        "03800": true,
        "03810": true,
        "03820": true,
        "03840": true,
        "03900": true,
        "03910": true,
        "03920": true,
        "03930": true,
        "03940": true
      },
      "Coyoacán": {
        "04000": true,
        "04010": true,
        "04020": true,
        "04030": true,
        "04040": true,
        "04100": true,
        "04120": true,
        "04200": true,
        "04210": true,
        "04230": true,
        "04240": true,
        "04250": true,
        "04260": true,
        "04300": true,
        "04310": true,
        "04318": true,
        "04320": true,
        "04330": true,
        "04340": true,
        "04360": true,
        "04369": true,
        "04370": true,
        "04380": true,
        "04390": true,
        "04400": true,
        "04410": true,
        "04420": true,
        "04440": true,
        "04450": true,
        "04460": true,
        "04470": true,
        "04480": true,
        "04489": true,
        "04490": true,
        "04500": true,
        "04510": true,
        "04519": true,
        "04530": true,
        "04600": true,
        "04610": true,
        "04620": true,
        "04630": true,
        "04640": true,
        "04650": true,
        "04660": true,
        "04700": true,
        "04710": true,
        "04730": true,
        "04739": true,
        "04800": true,
        "04810": true,
        "04815": true,
        "04830": true,
        "04840": true,
        "04870": true,
        "04890": true,
        "04899": true,
        "04909": true,
        "04910": true,
        "04918": true,
        "04919": true,
        "04920": true,
        "04929": true,
        "04930": true,
        "04938": true,
        "04939": true,
        "04940": true,
        "04950": true,
        "04960": true,
        "04970": true,
        "04980": true
      },
      "Cuauhtémoc": {
        "06000": true,
        "06010": true,
        "06020": true,
        "06030": true,
        "06040": true,
        "06050": true,
        "06060": true,
        "06070": true,
        "06080": true,
        "06090": true,
        "06100": true,
        "06140": true,
        "06170": true,
        "06200": true,
        "06220": true,
        "06240": true,
        "06250": true,
        "06270": true,
        "06280": true,
        "06300": true,
        "06350": true,
        "06400": true,
        "06430": true,
        "06450": true,
        "06470": true,
        "06500": true,
        "06600": true,
        "06700": true,
        "06720": true,
        "06760": true,
        "06780": true,
        "06800": true,
        "06820": true,
        "06840": true,
        "06850": true,
        "06860": true,
        "06870": true,
        "06880": true,
        "06890": true,
        "06900": true,
        "06920": true
      },
      "Gustavo A. Madero": {
        "07000": true,
        "07010": true,
        "07020": true,
        "07040": true,
        "07050": true,
        "07058": true,
        "07060": true,
        "07069": true,
        "07070": true,
        "07080": true,
        "07089": true,
        "07090": true,
        "07100": true,
        "07109": true,
        "07110": true,
        "07119": true,
        "07130": true,
        "07140": true,
        "07144": true,
        "07149": true,
        "07150": true,
        "07160": true,
        "07164": true,
        "07170": true,
        "07180": true,
        "07183": true,
        "07187": true,
        "07188": true,
        "07189": true,
        "07190": true,
        "07199": true,
        "07200": true,
        "07207": true,
        "07209": true,
        "07210": true,
        "07214": true,
        "07220": true,
        "07224": true,
        "07230": true,
        "07239": true,
        "07240": true,
        "07250": true,
        "07259": true,
        "07268": true,
        "07270": true,
        "07279": true,
        "07280": true,
        "07290": true,
        "07300": true,
        "07310": true,
        "07320": true,
        "07330": true,
        "07340": true,
        "07350": true,
        "07359": true,
        "07360": true,
        "07369": true,
        "07370": true,
        "07380": true,
        "07400": true,
        "07410": true,
        "07420": true,
        "07430": true,
        "07440": true,
        "07450": true,
        "07455": true,
        "07456": true,
        "07458": true,
        "07460": true,
        "07469": true,
        "07470": true,
        "07480": true,
        "07500": true,
        "07509": true,
        "07510": true,
        "07520": true,
        "07530": true,
        "07540": true,
        "07550": true,
        "07560": true,
        "07570": true,
        "07580": true,
        "07600": true,
        "07620": true,
        "07630": true,
        "07640": true,
        "07650": true,
        "07670": true,
        "07680": true,
        "07700": true,
        "07707": true,
        "07708": true,
        "07720": true,
        "07730": true,
        "07739": true,
        "07740": true,
        "07750": true,
        "07754": true,
        "07755": true,
        "07760": true,
        "07770": true,
        "07780": true,
        "07790": true,
        "07800": true,
        "07810": true,
        "07820": true,
        "07830": true,
        "07838": true,
        "07839": true,
        "07840": true,
        "07850": true,
        "07858": true,
        "07859": true,
        "07860": true,
        "07869": true,
        "07870": true,
        "07880": true,
        "07889": true,
        "07890": true,
        "07899": true,
        "07900": true,
        "07910": true,
        "07918": true,
        "07919": true,
        "07920": true,
        "07930": true,
        "07939": true,
        "07940": true,
        "07950": true,
        "07960": true,
        "07969": true,
        "07970": true,
        "07979": true,
        "07980": true,
        "07990": true
      },
      "Iztacalco": {
        "08000": true,
        "08010": true,
        "08020": true,
        "08030": true,
        "08040": true,
        "08100": true,
        "08200": true,
        "08210": true,
        "08220": true,
        "08230": true,
        "08240": true,
        "08300": true,
        "08310": true,
        "08320": true,
        "08400": true,
        "08420": true,
        "08500": true,
        "08510": true,
        "08600": true,
        "08610": true,
        "08620": true,
        "08650": true,
        "08700": true,
        "08710": true,
        "08720": true,
        "08730": true,
        "08760": true,
        "08770": true,
        "08800": true,
        "08810": true,
        "08830": true,
        "08840": true,
        "08900": true,
        "08910": true,
        "08920": true,
        "08930": true
      },
      "Iztapalapa": {
        "09000": true,
        "09010": true,
        "09020": true,
        "09030": true,
        "09040": true,
        "09060": true,
        "09070": true,
        "09080": true,
        "09089": true,
        "09090": true,
        "09099": true,
        "09100": true,
        "09130": true,
        "09140": true,
        "09180": true,
        "09200": true,
        "09208": true,
        "09209": true,
        "09210": true,
        "09220": true,
        "09230": true,
        "09239": true,
        "09240": true,
        "09250": true,
        "09260": true,
        "09270": true,
        "09280": true,
        "09290": true,
        "09300": true,
        "09310": true,
        "09319": true,
        "09320": true,
        "09350": true,
        "09359": true,
        "09360": true,
        "09400": true,
        "09410": true,
        "09420": true,
        "09429": true,
        "09430": true,
        "09438": true,
        "09440": true,
        "09450": true,
        "09460": true,
        "09470": true,
        "09479": true,
        "09480": true,
        "09500": true,
        "09510": true,
        "09520": true,
        "09530": true,
        "09550": true,
        "09560": true,
        "09570": true,
        "09578": true,
        "09600": true,
        "09608": true,
        "09609": true,
        "09620": true,
        "09630": true,
        "09637": true,
        "09638": true,
        "09640": true,
        "09648": true,
        "09660": true,
        "09670": true,
        "09680": true,
        "09689": true,
        "09690": true,
        "09696": true,
        "09698": true,
        "09700": true,
        "09704": true,
        "09705": true,
        "09706": true,
        "09708": true,
        "09709": true,
        "09710": true,
        "09720": true,
        "09730": true,
        "09740": true,
        "09750": true,
        "09760": true,
        "09769": true,
        "09770": true,
        "09780": true,
        "09790": true,
        "09800": true,
        "09810": true,
        "09819": true,
        "09820": true,
        "09828": true,
        "09829": true,
        "09830": true,
        "09837": true,
        "09838": true,
        "09839": true,
        "09840": true,
        "09849": true,
        "09850": true,
        "09856": true,
        "09858": true,
        "09859": true,
        "09860": true,
        "09868": true,
        "09870": true,
        "09880": true,
        "09890": true,
        "09897": true,
        "09900": true,
        "09910": true,
        "09920": true,
        "09930": true,
        "09940": true,
        "09960": true,
        "09969": true,
        "09970": true
      },
      "La Magdalena Contreras": {
        "10000": true,
        "10010": true,
        "10020": true,
        "10130": true,
        "10200": true,
        "10400": true,
        "10500": true,
        "10580": true,
        "10700": true,
        "10710": true,
        "10800": true,
        "10810": true,
        "10820": true,
        "10830": true,
        "10840": true,
        "10920": true
      },
      "Miguel Hidalgo": {
        "11000": true,
        "11040": true,
        "11100": true,
        "11200": true,
        "11210": true,
        "11220": true,
        "11230": true,
        "11240": true,
        "11250": true,
        "11260": true,
        "11270": true,
        "11280": true,
        "11289": true,
        "11290": true,
        "11300": true,
        "11310": true,
        "11320": true,
        "11330": true,
        "11340": true,
        "11350": true,
        "11360": true,
        "11370": true,
        "11400": true,
        "11410": true,
        "11420": true,
        "11430": true,
        "11440": true,
        "11450": true,
        "11460": true,
        "11470": true,
        "11480": true,
        "11489": true,
        "11490": true,
        "11500": true,
        "11510": true,
        "11520": true,
        "11529": true,
        "11530": true,
        "11540": true,
        "11550": true,
        "11560": true,
        "11580": true,
        "11590": true,
        "11600": true,
        "11610": true,
        "11619": true,
        "11650": true,
        "11700": true,
        "11800": true,
        "11810": true,
        "11820": true,
        "11830": true,
        "11840": true,
        "11850": true,
        "11860": true,
        "11870": true,
        "11910": true,
        "11920": true,
        "11930": true,
        "11950": true
      },
      "Tlalpan": {
        "14000": true,
        "14010": true,
        "14020": true,
        "14030": true,
        "14039": true,
        "14040": true,
        "14049": true,
        "14050": true,
        "14060": true,
        "14070": true,
        "14080": true,
        "14090": true,
        "14100": true,
        "14110": true,
        "14120": true,
        "14140": true,
        "14150": true,
        "14160": true,
        "14200": true,
        "14208": true,
        "14209": true,
        "14210": true,
        "14219": true,
        "14220": true,
        "14230": true,
        "14239": true,
        "14240": true,
        "14248": true,
        "14250": true,
        "14260": true,
        "14266": true,
        "14267": true,
        "14268": true,
        "14269": true,
        "14300": true,
        "14308": true,
        "14310": true,
        "14320": true,
        "14325": true,
        "14326": true,
        "14330": true,
        "14340": true,
        "14350": true,
        "14357": true,
        "14360": true,
        "14370": true,
        "14376": true,
        "14377": true,
        "14380": true,
        "14386": true,
        "14387": true,
        "14388": true,
        "14389": true,
        "14390": true,
        "14610": true,
        "14737": true,
        "14738": true
      },
      "Venustiano Carranza": {
        "15000": true,
        "15010": true,
        "15020": true,
        "15100": true,
        "15200": true,
        "15210": true,
        "15220": true,
        "15230": true,
        "15240": true,
        "15250": true,
        "15260": true,
        "15270": true,
        "15280": true,
        "15290": true,
        "15300": true,
        "15309": true,
        "15310": true,
        "15320": true,
        "15330": true,
        "15339": true,
        "15340": true,
        "15350": true,
        "15370": true,
        "15380": true,
        "15390": true,
        "15400": true,
        "15410": true,
        "15420": true,
        "15430": true,
        "15440": true,
        "15450": true,
        "15460": true,
        "15470": true,
        "15500": true,
        "15510": true,
        "15520": true,
        "15530": true,
        "15540": true,
        "15600": true,
        "15610": true,
        "15620": true,
        "15630": true,
        "15640": true,
        "15650": true,
        "15660": true,
        "15670": true,
        "15680": true,
        "15700": true,
        "15710": true,
        "15730": true,
        "15740": true,
        "15750": true,
        "15800": true,
        "15810": true,
        "15820": true,
        "15830": true,
        "15840": true,
        "15850": true,
        "15860": true,
        "15870": true,
        "15900": true,
        "15960": true,
        "15970": true,
        "15980": true,
        "15990": true
      },
      "Xochimilco": {
        "16010": true,
        "16020": true,
        "16035": true,
        "16036": true
      },
      "Álvaro Obregón": {
        "01000": true,
        "01010": true,
        "01020": true,
        "01030": true,
        "01040": true,
        "01049": true,
        "01050": true,
        "01060": true,
        "01070": true,
        "01080": true,
        "01089": true,
        "01090": true,
        "01100": true,
        "01109": true,
        "01110": true,
        "01120": true,
        "01125": true,
        "01130": true,
        "01139": true,
        "01140": true,
        "01150": true,
        "01160": true,
        "01170": true,
        "01180": true,
        "01200": true,
        "01210": true,
        "01219": true,
        "01220": true,
        "01230": true,
        "01239": true,
        "01240": true,
        "01250": true,
        "01259": true,
        "01260": true,
        "01269": true,
        "01270": true,
        "01275": true,
        "01276": true,
        "01278": true,
        "01279": true,
        "01280": true,
        "01285": true,
        "01289": true,
        "01290": true,
        "01296": true,
        "01298": true,
        "01299": true,
        "01320": true,
        "01340": true,
        "01376": true,
        "01377": true,
        "01389": true,
        "01400": true,
        "01407": true,
        "01408": true,
        "01410": true,
        "01419": true,
        "01420": true,
        "01430": true,
        "01450": true,
        "01460": true,
        "01470": true,
        "01480": true,
        "01490": true,
        "01500": true,
        "01509": true,
        "01510": true,
        "01520": true,
        "01530": true,
        "01538": true,
        "01539": true,
        "01540": true,
        "01548": true,
        "01549": true,
        "01550": true,
        "01560": true,
        "01566": true,
        "01569": true,
        "01588": true,
        "01590": true,
        "01600": true,
        "01610": true,
        "01618": true,
        "01619": true,
        "01620": true,
        "01630": true,
        "01640": true,
        "01645": true,
        "01650": true,
        "01700": true,
        "01708": true,
        "01710": true,
        "01720": true,
        "01729": true,
        "01730": true,
        "01740": true,
        "01750": true,
        "01759": true,
        "01760": true,
        "01770": true,
        "01780": true,
        "01789": true,
        "01790": true,
        "01807": true,
        "01810": true,
        "01820": true,
        "01840": true,
        "01849": true,
        "01900": true,
        "01904": true
      }
    },
    "Coahuila de Zaragoza": {
      "Arteaga": {
        "25350": true,
        "25352": true,
        "25353": true,
        "25354": true,
        "25355": true,
        "25356": true,
        "25369": true
      },
      "Ramos Arizpe": {
        "25900": true,
        "25902": true,
        "25903": true,
        "25904": true,
        "25905": true
      },
      "Saltillo": {
        "25000": true,
        "25008": true,
        "25010": true,
        "25013": true,
        "25014": true,
        "25015": true,
        "25016": true,
        "25017": true,
        "25019": true,
        "25020": true,
        "25022": true,
        "25023": true,
        "25030": true,
        "25034": true,
        "25036": true,
        "25038": true,
        "25039": true,
        "25040": true,
        "25043": true,
        "25044": true,
        "25045": true,
        "25047": true,
        "25048": true,
        "25049": true,
        "25050": true,
        "25056": true,
        "25057": true,
        "25060": true,
        "25065": true,
        "25067": true,
        "25068": true,
        "25069": true,
        "25070": true,
        "25075": true,
        "25076": true,
        "25077": true,
        "25080": true,
        "25083": true,
        "25084": true,
        "25085": true,
        "25086": true,
        "25087": true,
        "25088": true,
        "25090": true,
        "25092": true,
        "25093": true,
        "25094": true,
        "25096": true,
        "25097": true,
        "25100": true,
        "25107": true,
        "25110": true,
        "25113": true,
        "25114": true,
        "25115": true,
        "25116": true,
        "25117": true,
        "25120": true,
        "25123": true,
        "25124": true,
        "25125": true,
        "25128": true,
        "25130": true,
        "25137": true,
        "25138": true,
        "25140": true,
        "25146": true,
        "25147": true,
        "25150": true,
        "25155": true,
        "25156": true,
        "25157": true,
        "25160": true,
        "25167": true,
        "25168": true,
        "25169": true,
        "25170": true,
        "25179": true,
        "25180": true,
        "25186": true,
        "25188": true,
        "25190": true,
        "25193": true,
        "25194": true,
        "25195": true,
        "25196": true,
        "25197": true,
        "25198": true,
        "25199": true,
        "25200": true,
        "25203": true,
        "25204": true,
        "25205": true,
        "25206": true,
        "25207": true,
        "25208": true,
        "25209": true,
        "25210": true,
        "25215": true,
        "25220": true,
        "25225": true,
        "25230": true,
        "25239": true,
        "25240": true,
        "25250": true,
        "25253": true,
        "25254": true,
        "25256": true,
        "25260": true,
        "25265": true,
        "25270": true,
        "25277": true,
        "25279": true,
        "25280": true,
        "25284": true,
        "25285": true,
        "25286": true,
        "25290": true,
        "25293": true,
        "25294": true,
        "25295": true,
        "25296": true,
        "25297": true,
        "25298": true
      }
    },
    "Guanajuato": {
      "León": {
        "37000": true,
        "37004": true,
        "37010": true,
        "37020": true,
        "37100": true,
        "37104": true,
        "37105": true,
        "37106": true,
        "37107": true,
        "37108": true,
        "37109": true,
        "37110": true,
        "37118": true,
        "37119": true,
        "37120": true,
        "37123": true,
        "37125": true,
        "37128": true,
        "37129": true,
        "37130": true,
        "37134": true,
        "37138": true,
        "37140": true,
        "37147": true,
        "37148": true,
        "37149": true,
        "37150": true,
        "37156": true,
        "37157": true,
        "37160": true,
        "37168": true,
        "37170": true,
        "37178": true,
        "37179": true,
        "37180": true,
        "37187": true,
        "37188": true,
        "37189": true,
        "37190": true,
        "37199": true,
        "37200": true,
        "37204": true,
        "37205": true,
        "37207": true,
        "37208": true,
        "37209": true,
        "37210": true,
        "37217": true,
        "37218": true,
        "37219": true,
        "37220": true,
        "37225": true,
        "37227": true,
        "37230": true,
        "37233": true,
        "37234": true,
        "37235": true,
        "37236": true,
        "37237": true,
        "37238": true,
        "37239": true,
        "37240": true,
        "37249": true,
        "37250": true,
        "37257": true,
        "37258": true,
        "37259": true,
        "37260": true,
        "37266": true,
        "37267": true,
        "37268": true,
        "37269": true,
        "37270": true,
        "37276": true,
        "37277": true,
        "37278": true,
        "37279": true,
        "37280": true,
        "37287": true,
        "37288": true,
        "37289": true,
        "37290": true,
        "37293": true,
        "37294": true,
        "37295": true,
        "37296": true,
        "37297": true,
        "37298": true,
        "37299": true,
        "37300": true,
        "37306": true,
        "37310": true,
        "37315": true,
        "37316": true,
        "37318": true,
        "37319": true,
        "37320": true,
        "37327": true,
        "37328": true,
        "37330": true,
        "37340": true,
        "37350": true,
        "37353": true,
        "37355": true,
        "37357": true,
        "37358": true,
        "37359": true,
        "37360": true,
        "37364": true,
        "37366": true,
        "37368": true,
        "37369": true,
        "37380": true,
        "37390": true,
        "37400": true,
        "37407": true,
        "37408": true,
        "37410": true,
        "37414": true,
        "37415": true,
        "37416": true,
        "37417": true,
        "37419": true,
        "37420": true,
        "37425": true,
        "37426": true,
        "37427": true,
        "37428": true,
        "37430": true,
        "37434": true,
        "37436": true,
        "37438": true,
        "37439": true,
        "37440": true,
        "37443": true,
        "37444": true,
        "37446": true,
        "37448": true,
        "37450": true,
        "37455": true,
        "37456": true,
        "37457": true,
        "37458": true,
        "37459": true,
        "37460": true,
        "37468": true,
        "37470": true,
        "37477": true,
        "37478": true,
        "37479": true,
        "37480": true,
        "37487": true,
        "37490": true,
        "37500": true,
        "37510": true,
        "37520": true,
        "37526": true,
        "37530": true,
        "37536": true,
        "37538": true,
        "37539": true,
        "37544": true,
        "37545": true,
        "37547": true,
        "37548": true,
        "37549": true,
        "37550": true,
        "37555": true,
        "37557": true,
        "37560": true,
        "37564": true,
        "37570": true,
        "37590": true,
        "37677": true,
        "37680": true,
        "37684": true,
        "37685": true
      }
    },
    "Jalisco": {
      "Guadalajara": {
        "44100": true,
        "44110": true,
        "44130": true,
        "44140": true,
        "44150": true,
        "44158": true,
        "44160": true,
        "44170": true,
        "44180": true,
        "44190": true,
        "44200": true,
        "44210": true,
        "44214": true,
        "44215": true,
        "44216": true,
        "44217": true,
        "44218": true,
        "44219": true,
        "44220": true,
        "44227": true,
        "44230": true,
        "44240": true,
        "44246": true,
        "44247": true,
        "44260": true,
        "44265": true,
        "44266": true,
        "44267": true,
        "44270": true,
        "44280": true,
        "44290": true,
        "44298": true,
        "44299": true,
        "44300": true,
        "44306": true,
        "44307": true,
        "44320": true,
        "44329": true,
        "44330": true,
        "44340": true,
        "44350": true,
        "44360": true,
        "44370": true,
        "44380": true,
        "44400": true,
        "44410": true,
        "44420": true,
        "44430": true,
        "44440": true,
        "44450": true,
        "44460": true,
        "44467": true,
        "44469": true,
        "44470": true,
        "44490": true,
        "44493": true,
        "44500": true,
        "44509": true,
        "44510": true,
        "44520": true,
        "44530": true,
        "44535": true,
        "44538": true,
        "44540": true,
        "44549": true,
        "44550": true,
        "44559": true,
        "44560": true,
        "44580": true,
        "44600": true,
        "44610": true,
        "44619": true,
        "44620": true,
        "44630": true,
        "44635": true,
        "44647": true,
        "44648": true,
        "44650": true,
        "44656": true,
        "44657": true,
        "44658": true,
        "44660": true,
        "44665": true,
        "44667": true,
        "44668": true,
        "44670": true,
        "44678": true,
        "44679": true,
        "44680": true,
        "44689": true,
        "44690": true,
        "44700": true,
        "44710": true,
        "44716": true,
        "44719": true,
        "44720": true,
        "44723": true,
        "44724": true,
        "44725": true,
        "44726": true,
        "44727": true,
        "44730": true,
        "44737": true,
        "44740": true,
        "44748": true,
        "44750": true,
        "44755": true,
        "44757": true,
        "44765": true,
        "44770": true,
        "44780": true,
        "44790": true,
        "44799": true,
        "44800": true,
        "44810": true,
        "44815": true,
        "44817": true,
        "44818": true,
        "44820": true,
        "44824": true,
        "44825": true,
        "44827": true,
        "44828": true,
        "44829": true,
        "44840": true,
        "44860": true,
        "44870": true,
        "44890": true,
        "44895": true,
        "44896": true,
        "44897": true,
        "44898": true,
        "44899": true,
        "44900": true,
        "44910": true,
        "44918": true,
        "44919": true,
        "44920": true,
        "44929": true,
        "44930": true,
        "44940": true,
        "44948": true,
        "44949": true,
        "44950": true,
        "44956": true,
        "44959": true,
        "44960": true,
        "44966": true,
        "44967": true,
        "44969": true,
        "44970": true,
        "44977": true,
        "44978": true,
        "44980": true,
        "44984": true,
        "44985": true,
        "44986": true,
        "44987": true,
        "44989": true,
        "44990": true
      },
      "San Pedro Tlaquepaque": {
        "45500": true,
        "45509": true,
        "45510": true,
        "45519": true,
        "45520": true,
        "45525": true,
        "45527": true,
        "45528": true,
        "45530": true,
        "45535": true,
        "45540": true,
        "45550": true,
        "45559": true,
        "45560": true,
        "45567": true,
        "45570": true,
        "45579": true,
        "45580": true,
        "45588": true,
        "45589": true,
        "45590": true,
        "45593": true,
        "45594": true,
        "45595": true,
        "45596": true,
        "45597": true,
        "45598": true,
        "45599": true,
        "45601": true,
        "45604": true,
        "45605": true,
        "45606": true,
        "45607": true,
        "45608": true,
        "45609": true,
        "45610": true,
        "45619": true,
        "45620": true,
        "45623": true,
        "45625": true,
        "45626": true,
        "45627": true,
        "45628": true,
        "45629": true,
        "45630": true,
        "45638": true
      },
      "Tonalá": {
        "45400": true,
        "45402": true,
        "45403": true
      },
      "Zapopan": {
        "45010": true,
        "45016": true,
        "45018": true,
        "45020": true,
        "45027": true,
        "45030": true,
        "45034": true,
        "45036": true,
        "45037": true,
        "45038": true,
        "45039": true,
        "45040": true,
        "45047": true,
        "45049": true,
        "45050": true,
        "45053": true,
        "45054": true,
        "45055": true,
        "45056": true,
        "45057": true,
        "45058": true,
        "45059": true,
        "45060": true,
        "45066": true,
        "45067": true,
        "45069": true,
        "45070": true,
        "45076": true,
        "45077": true,
        "45078": true,
        "45079": true,
        "45080": true,
        "45085": true,
        "45086": true,
        "45087": true,
        "45088": true,
        "45089": true,
        "45100": true,
        "45110": true,
        "45115": true,
        "45116": true,
        "45117": true,
        "45118": true,
        "45119": true,
        "45120": true,
        "45128": true,
        "45129": true,
        "45130": true,
        "45136": true,
        "45138": true,
        "45140": true,
        "45145": true,
        "45146": true,
        "45147": true,
        "45148": true,
        "45149": true,
        "45150": true,
        "45157": true,
        "45158": true,
        "45159": true,
        "45160": true,
        "45167": true,
        "45168": true,
        "45169": true,
        "45170": true,
        "45176": true,
        "45177": true,
        "45178": true,
        "45179": true,
        "45180": true,
        "45184": true,
        "45190": true,
        "45230": true,
        "45234": true,
        "45235": true,
        "45236": true,
        "45237": true,
        "45238": true,
        "45239": true
      }
    },
    "México": {
      "Atizapán de Zaragoza": {
        "52900": true,
        "52910": true,
        "52915": true,
        "52918": true,
        "52919": true,
        "52920": true,
        "52923": true,
        "52924": true,
        "52925": true,
        "52926": true,
        "52927": true,
        "52928": true,
        "52929": true,
        "52940": true,
        "52945": true,
        "52946": true,
        "52947": true,
        "52948": true,
        "52949": true,
        "52950": true,
        "52953": true,
        "52957": true,
        "52959": true,
        "52960": true,
        "52965": true,
        "52966": true,
        "52967": true,
        "52968": true,
        "52970": true,
        "52975": true,
        "52976": true,
        "52977": true,
        "52978": true,
        "52979": true,
        "52985": true,
        "52986": true,
        "52987": true,
        "52988": true,
        "52990": true,
        "52994": true,
        "52995": true,
        "52996": true,
        "52997": true,
        "52998": true
      },
      "Chicoloapan": {
        "56390": true
      },
      "Chimalhuacán": {
        "56330": true,
        "56334": true,
        "56335": true,
        "56337": true,
        "56340": true,
        "56343": true,
        "56344": true,
        "56346": true,
        "56350": true,
        "56353": true,
        "56356": true,
        "56360": true,
        "56363": true,
        "56366": true
      },
      "Coacalco de Berriozábal": {
        "55700": true,
        "55705": true,
        "55707": true,
        "55708": true,
        "55709": true,
        "55710": true,
        "55712": true,
        "55713": true,
        "55714": true,
        "55715": true,
        "55716": true,
        "55717": true,
        "55718": true,
        "55719": true,
        "55720": true,
        "55726": true,
        "55728": true,
        "55729": true,
        "55730": true,
        "55736": true,
        "55737": true,
        "55738": true,
        "55739": true
      },
      "Cuautitlán": {
        "54800": true,
        "54804": true,
        "54805": true,
        "54807": true,
        "54850": true,
        "54855": true,
        "54857": true,
        "54858": true,
        "54860": true,
        "54870": true,
        "54875": true,
        "54877": true,
        "54878": true,
        "54879": true
      },
      "Cuautitlán Izcalli": {
        "54700": true,
        "54712": true,
        "54720": true,
        "54725": true,
        "54729": true,
        "54730": true,
        "54740": true,
        "54743": true,
        "54744": true,
        "54750": true,
        "54753": true,
        "54759": true,
        "54760": true,
        "54763": true,
        "54764": true,
        "54765": true,
        "54766": true,
        "54767": true,
        "54769": true
      },
      "Ecatepec de Morelos": {
        "55000": true,
        "55010": true,
        "55014": true,
        "55016": true,
        "55017": true,
        "55018": true,
        "55020": true,
        "55023": true,
        "55024": true,
        "55025": true,
        "55027": true,
        "55028": true,
        "55029": true,
        "55030": true,
        "55036": true,
        "55037": true,
        "55038": true,
        "55039": true,
        "55040": true,
        "55050": true,
        "55055": true,
        "55056": true,
        "55059": true,
        "55060": true,
        "55064": true,
        "55065": true,
        "55066": true,
        "55067": true,
        "55068": true,
        "55069": true,
        "55070": true,
        "55074": true,
        "55075": true,
        "55076": true,
        "55080": true,
        "55084": true,
        "55085": true,
        "55090": true,
        "55094": true,
        "55095": true,
        "55100": true,
        "55104": true,
        "55105": true,
        "55107": true,
        "55114": true,
        "55115": true,
        "55117": true,
        "55118": true,
        "55119": true,
        "55120": true,
        "55125": true,
        "55126": true,
        "55127": true,
        "55128": true,
        "55129": true,
        "55130": true,
        "55135": true,
        "55137": true,
        "55138": true,
        "55139": true,
        "55140": true,
        "55146": true,
        "55147": true,
        "55148": true,
        "55149": true,
        "55158": true,
        "55170": true,
        "55176": true,
        "55180": true,
        "55187": true,
        "55188": true,
        "55189": true,
        "55190": true,
        "55200": true,
        "55210": true,
        "55218": true,
        "55220": true,
        "55230": true,
        "55234": true,
        "55235": true,
        "55236": true,
        "55237": true,
        "55238": true,
        "55240": true,
        "55242": true,
        "55243": true,
        "55244": true,
        "55245": true,
        "55246": true,
        "55247": true,
        "55248": true,
        "55249": true,
        "55260": true,
        "55264": true,
        "55266": true,
        "55267": true,
        "55268": true,
        "55269": true,
        "55270": true,
        "55280": true,
        "55284": true,
        "55287": true,
        "55288": true,
        "55289": true,
        "55290": true,
        "55294": true,
        "55295": true,
        "55296": true,
        "55297": true,
        "55298": true,
        "55299": true,
        "55300": true,
        "55308": true,
        "55310": true,
        "55316": true,
        "55317": true,
        "55320": true,
        "55330": true,
        "55338": true,
        "55339": true,
        "55340": true,
        "55347": true,
        "55348": true,
        "55349": true,
        "55360": true,
        "55369": true,
        "55390": true,
        "55400": true,
        "55404": true,
        "55405": true,
        "55407": true,
        "55410": true,
        "55414": true,
        "55415": true,
        "55416": true,
        "55417": true,
        "55418": true,
        "55419": true,
        "55420": true,
        "55425": true,
        "55429": true,
        "55430": true,
        "55450": true,
        "55458": true,
        "55459": true,
        "55490": true,
        "55498": true,
        "55500": true,
        "55506": true,
        "55507": true,
        "55508": true,
        "55509": true,
        "55510": true,
        "55515": true,
        "55516": true,
        "55517": true,
        "55518": true,
        "55519": true,
        "55520": true,
        "55530": true,
        "55540": true,
        "55547": true,
        "55548": true,
        "55549": true
      },
      "Huixquilucan": {
        "52770": true,
        "52780": true,
        "52784": true
      },
      "Jaltenco": {
        "55783": true
      },
      "La Paz": {
        "56400": true,
        "56410": true,
        "56420": true,
        "56428": true,
        "56429": true,
        "56430": true,
        "56440": true,
        "56490": true,
        "56500": true,
        "56505": true,
        "56520": true,
        "56524": true,
        "56525": true,
        "56526": true,
        "56527": true,
        "56528": true,
        "56529": true
      },
      "Lerma": {
        "52004": true
      },
      "Metepec": {
        "52140": true,
        "52148": true,
        "52149": true,
        "52150": true,
        "52156": true,
        "52157": true,
        "52158": true,
        "52159": true,
        "52160": true,
        "52164": true,
        "52165": true,
        "52166": true,
        "52167": true,
        "52168": true,
        "52169": true,
        "52170": true,
        "52172": true,
        "52175": true,
        "52176": true,
        "52177": true,
        "52178": true,
        "52179": true
      },
      "Naucalpan de Juárez": {
        "53000": true,
        "53010": true,
        "53030": true,
        "53040": true,
        "53050": true,
        "53060": true,
        "53070": true,
        "53100": true,
        "53110": true,
        "53115": true,
        "53116": true,
        "53117": true,
        "53119": true,
        "53125": true,
        "53127": true,
        "53128": true,
        "53129": true,
        "53130": true,
        "53138": true,
        "53140": true,
        "53150": true,
        "53160": true,
        "53170": true,
        "53177": true,
        "53178": true,
        "53200": true,
        "53215": true,
        "53218": true,
        "53220": true,
        "53224": true,
        "53227": true,
        "53230": true,
        "53237": true,
        "53239": true,
        "53240": true,
        "53247": true,
        "53248": true,
        "53250": true,
        "53260": true,
        "53270": true,
        "53278": true,
        "53279": true,
        "53280": true,
        "53283": true,
        "53290": true,
        "53296": true,
        "53297": true,
        "53298": true,
        "53300": true,
        "53309": true,
        "53310": true,
        "53320": true,
        "53329": true,
        "53330": true,
        "53338": true,
        "53339": true,
        "53340": true,
        "53348": true,
        "53350": true,
        "53370": true,
        "53378": true,
        "53390": true,
        "53398": true,
        "53400": true,
        "53410": true,
        "53420": true,
        "53425": true,
        "53426": true,
        "53427": true,
        "53428": true,
        "53430": true,
        "53440": true,
        "53450": true,
        "53458": true,
        "53459": true,
        "53460": true,
        "53470": true,
        "53489": true,
        "53490": true,
        "53500": true,
        "53519": true,
        "53520": true,
        "53529": true,
        "53530": true,
        "53533": true,
        "53550": true,
        "53560": true,
        "53569": true,
        "53570": true,
        "53580": true,
        "53598": true,
        "53640": true,
        "53660": true,
        "53664": true,
        "53670": true,
        "53680": true,
        "53687": true,
        "53688": true,
        "53689": true,
        "53690": true,
        "53696": true,
        "53697": true,
        "53698": true,
        "53700": true,
        "53708": true,
        "53710": true,
        "53713": true,
        "53714": true,
        "53716": true,
        "53717": true,
        "53718": true,
        "53719": true,
        "53730": true,
        "53760": true,
        "53770": true,
        "53780": true,
        "53787": true,
        "53788": true,
        "53790": true,
        "53798": true,
        "53799": true,
        "53800": true,
        "53809": true,
        "53810": true,
        "53819": true,
        "53820": true,
        "53830": true,
        "53839": true,
        "53840": true,
        "53900": true,
        "53909": true,
        "53910": true,
        "53930": true,
        "53940": true,
        "53950": true,
        "53960": true,
        "53970": true
      },
      "Nezahualcóyotl": {
        "57000": true,
        "57100": true,
        "57103": true,
        "57120": true,
        "57129": true,
        "57130": true,
        "57138": true,
        "57139": true,
        "57140": true,
        "57150": true,
        "57158": true,
        "57170": true,
        "57171": true,
        "57178": true,
        "57179": true,
        "57180": true,
        "57185": true,
        "57188": true,
        "57189": true,
        "57200": true,
        "57205": true,
        "57210": true,
        "57300": true,
        "57310": true,
        "57400": true,
        "57410": true,
        "57420": true,
        "57430": true,
        "57440": true,
        "57450": true,
        "57460": true,
        "57500": true,
        "57510": true,
        "57520": true,
        "57530": true,
        "57600": true,
        "57610": true,
        "57620": true,
        "57630": true,
        "57700": true,
        "57708": true,
        "57709": true,
        "57710": true,
        "57718": true,
        "57719": true,
        "57720": true,
        "57730": true,
        "57739": true,
        "57740": true,
        "57750": true,
        "57760": true,
        "57800": true,
        "57809": true,
        "57810": true,
        "57819": true,
        "57820": true,
        "57830": true,
        "57840": true,
        "57849": true,
        "57900": true,
        "57910": true,
        "57920": true,
        "57930": true,
        "57940": true,
        "57950": true
      },
      "Nicolás Romero": {
        "54473": true,
        "54474": true,
        "54475": true,
        "54476": true
      },
      "San Mateo Atenco": {
        "52100": true,
        "52104": true,
        "52105": true,
        "52110": true,
        "52120": true
      },
      "Tecámac": {
        "55763": true,
        "55764": true
      },
      "Tlalnepantla de Baz": {
        "54000": true,
        "54009": true,
        "54010": true,
        "54015": true,
        "54016": true,
        "54017": true,
        "54020": true,
        "54021": true,
        "54022": true,
        "54023": true,
        "54025": true,
        "54026": true,
        "54028": true,
        "54030": true,
        "54033": true,
        "54037": true,
        "54038": true,
        "54040": true,
        "54049": true,
        "54050": true,
        "54054": true,
        "54055": true,
        "54057": true,
        "54059": true,
        "54060": true,
        "54063": true,
        "54067": true,
        "54068": true,
        "54069": true,
        "54070": true,
        "54073": true,
        "54075": true,
        "54076": true,
        "54080": true,
        "54090": true,
        "54092": true,
        "54093": true,
        "54094": true,
        "54098": true,
        "54100": true,
        "54108": true,
        "54109": true,
        "54110": true,
        "54118": true,
        "54119": true,
        "54120": true,
        "54124": true,
        "54126": true,
        "54127": true,
        "54128": true,
        "54130": true,
        "54134": true,
        "54135": true,
        "54136": true,
        "54140": true,
        "54142": true,
        "54143": true,
        "54145": true,
        "54146": true,
        "54147": true,
        "54149": true,
        "54150": true,
        "54152": true,
        "54158": true,
        "54160": true,
        "54162": true,
        "54168": true,
        "54170": true,
        "54172": true,
        "54173": true,
        "54180": true,
        "54187": true,
        "54189": true,
        "54190": true,
        "54193": true,
        "54195": true,
        "54196": true,
        "54197": true,
        "54198": true
      },
      "Toluca": {
        "50000": true,
        "50010": true,
        "50016": true,
        "50020": true,
        "50026": true,
        "50040": true,
        "50050": true,
        "50060": true,
        "50070": true,
        "50071": true,
        "50075": true,
        "50080": true,
        "50090": true,
        "50100": true,
        "50103": true,
        "50110": true,
        "50115": true,
        "50120": true,
        "50122": true,
        "50130": true,
        "50140": true,
        "50150": true,
        "50160": true,
        "50168": true,
        "50170": true,
        "50180": true,
        "50190": true,
        "50200": true,
        "50205": true,
        "50206": true,
        "50210": true,
        "50214": true,
        "50220": true,
        "50225": true,
        "50226": true,
        "50227": true,
        "50228": true,
        "50240": true,
        "50245": true,
        "50246": true,
        "50250": true,
        "50253": true,
        "50254": true,
        "50260": true,
        "50263": true,
        "50264": true,
        "50265": true,
        "50290": true,
        "50294": true
      },
      "Tultepec": {
        "54963": true,
        "54980": true,
        "54983": true,
        "54984": true,
        "54985": true,
        "54986": true,
        "54987": true
      },
      "Tultitlán": {
        "54900": true,
        "54910": true,
        "54913": true,
        "54914": true,
        "54915": true,
        "54916": true,
        "54918": true,
        "54920": true,
        "54924": true,
        "54925": true,
        "54926": true,
        "54927": true,
        "54929": true,
        "54930": true,
        "54932": true,
        "54933": true,
        "54934": true,
        "54935": true,
        "54938": true,
        "54939": true,
        "54940": true,
        "54942": true,
        "54943": true,
        "54944": true,
        "54945": true,
        "54946": true,
        "54948": true,
        "54949": true,
        "54950": true,
        "54954": true,
        "54955": true,
        "54957": true,
        "54958": true,
        "54959": true
      },
      "Zinacantepec": {
        "51356": true
      }
    },
    "Nuevo León": {
      "Apodaca": {
        "66600": true,
        "66603": true,
        "66604": true,
        "66605": true,
        "66606": true,
        "66607": true,
        "66609": true,
        "66610": true,
        "66612": true,
        "66613": true,
        "66614": true,
        "66630": true,
        "66632": true,
        "66633": true,
        "66634": true,
        "66635": true,
        "66636": true,
        "66637": true,
        "66640": true,
        "66643": true,
        "66644": true,
        "66645": true,
        "66646": true,
        "66647": true,
        "66648": true,
        "66649": true
      },
      "García": {
        "66023": true,
        "66024": true
      },
      "General Escobedo": {
        "66050": true,
        "66051": true,
        "66052": true,
        "66053": true,
        "66054": true,
        "66055": true,
        "66056": true,
        "66057": true,
        "66058": true,
        "66059": true,
        "66061": true,
        "66062": true,
        "66064": true,
        "66070": true,
        "66072": true,
        "66073": true
      },
      "Guadalupe": {
        "67100": true,
        "67110": true,
        "67112": true,
        "67113": true,
        "67115": true,
        "67116": true,
        "67117": true,
        "67118": true,
        "67119": true,
        "67120": true,
        "67123": true,
        "67124": true,
        "67125": true,
        "67126": true,
        "67128": true,
        "67129": true,
        "67130": true,
        "67132": true,
        "67133": true,
        "67134": true,
        "67140": true,
        "67144": true,
        "67150": true,
        "67153": true,
        "67154": true,
        "67155": true,
        "67160": true,
        "67163": true,
        "67164": true,
        "67165": true,
        "67167": true,
        "67168": true,
        "67169": true,
        "67170": true,
        "67173": true,
        "67174": true,
        "67175": true,
        "67176": true,
        "67177": true,
        "67178": true,
        "67179": true,
        "67180": true,
        "67182": true,
        "67183": true,
        "67184": true,
        "67185": true,
        "67186": true,
        "67188": true,
        "67189": true,
        "67190": true,
        "67192": true,
        "67193": true,
        "67194": true,
        "67195": true,
        "67196": true,
        "67197": true,
        "67198": true,
        "67199": true,
        "67200": true,
        "67202": true,
        "67203": true,
        "67204": true,
        "67205": true
      },
      "Juárez": {
        "67258": true,
        "67287": true,
        "67288": true,
        "67289": true
      },
      "Monterrey": {
        "64000": true,
        "64010": true,
        "64018": true,
        "64019": true,
        "64020": true,
        "64030": true,
        "64040": true,
        "64049": true,
        "64050": true,
        "64060": true,
        "64070": true,
        "64100": true,
        "64102": true,
        "64103": true,
        "64104": true,
        "64105": true,
        "64106": true,
        "64107": true,
        "64108": true,
        "64109": true,
        "64110": true,
        "64116": true,
        "64117": true,
        "64118": true,
        "64119": true,
        "64120": true,
        "64130": true,
        "64140": true,
        "64145": true,
        "64148": true,
        "64150": true,
        "64157": true,
        "64158": true,
        "64159": true,
        "64160": true,
        "64165": true,
        "64167": true,
        "64168": true,
        "64170": true,
        "64178": true,
        "64180": true,
        "64186": true,
        "64190": true,
        "64200": true,
        "64204": true,
        "64205": true,
        "64206": true,
        "64208": true,
        "64209": true,
        "64210": true,
        "64215": true,
        "64217": true,
        "64218": true,
        "64219": true,
        "64220": true,
        "64226": true,
        "64228": true,
        "64230": true,
        "64233": true,
        "64234": true,
        "64235": true,
        "64236": true,
        "64238": true,
        "64240": true,
        "64244": true,
        "64245": true,
        "64246": true,
        "64247": true,
        "64250": true,
        "64259": true,
        "64260": true,
        "64264": true,
        "64265": true,
        "64266": true,
        "64268": true,
        "64269": true,
        "64270": true,
        "64280": true,
        "64290": true,
        "64299": true,
        "64300": true,
        "64310": true,
        "64320": true,
        "64330": true,
        "64339": true,
        "64340": true,
        "64344": true,
        "64345": true,
        "64346": true,
        "64347": true,
        "64348": true,
        "64349": true,
        "64350": true,
        "64360": true,
        "64365": true,
        "64366": true,
        "64367": true,
        "64368": true,
        "64369": true,
        "64370": true,
        "64380": true,
        "64390": true,
        "64400": true,
        "64410": true,
        "64420": true,
        "64430": true,
        "64440": true,
        "64450": true,
        "64460": true,
        "64470": true,
        "64480": true,
        "64488": true,
        "64489": true,
        "64490": true,
        "64500": true,
        "64508": true,
        "64510": true,
        "64517": true,
        "64520": true,
        "64530": true,
        "64536": true,
        "64540": true,
        "64549": true,
        "64550": true,
        "64560": true,
        "64568": true,
        "64570": true,
        "64580": true,
        "64590": true,
        "64600": true,
        "64610": true,
        "64618": true,
        "64619": true,
        "64620": true,
        "64623": true,
        "64630": true,
        "64632": true,
        "64633": true,
        "64634": true,
        "64635": true,
        "64636": true,
        "64637": true,
        "64638": true,
        "64639": true,
        "64640": true,
        "64649": true,
        "64650": true,
        "64659": true,
        "64660": true,
        "64700": true,
        "64710": true,
        "64715": true,
        "64718": true,
        "64720": true,
        "64730": true,
        "64740": true,
        "64750": true,
        "64753": true,
        "64754": true,
        "64760": true,
        "64764": true,
        "64765": true,
        "64770": true,
        "64780": true,
        "64783": true,
        "64788": true,
        "64790": true,
        "64798": true,
        "64800": true,
        "64810": true,
        "64820": true,
        "64830": true,
        "64833": true,
        "64834": true,
        "64836": true,
        "64840": true,
        "64844": true,
        "64845": true,
        "64849": true,
        "64850": true,
        "64858": true,
        "64859": true,
        "64860": true,
        "64865": true,
        "64878": true,
        "64880": true,
        "64890": true,
        "64893": true,
        "64898": true,
        "64900": true,
        "64909": true,
        "64910": true,
        "64920": true,
        "64926": true,
        "64930": true,
        "64940": true,
        "64949": true,
        "64950": true,
        "64960": true,
        "64968": true,
        "64969": true,
        "64970": true,
        "64978": true,
        "64983": true,
        "64984": true,
        "64985": true,
        "64986": true,
        "64987": true,
        "64988": true,
        "64989": true,
        "64990": true,
        "64996": true
      },
      "San Nicolás de los Garza": {
        "66400": true,
        "66410": true,
        "66413": true,
        "66414": true,
        "66415": true,
        "66417": true,
        "66418": true,
        "66420": true,
        "66422": true,
        "66425": true,
        "66427": true,
        "66428": true,
        "66430": true,
        "66435": true,
        "66436": true,
        "66437": true,
        "66438": true,
        "66440": true,
        "66444": true,
        "66445": true,
        "66446": true,
        "66447": true,
        "66448": true,
        "66449": true,
        "66450": true,
        "66455": true,
        "66456": true,
        "66457": true,
        "66458": true,
        "66460": true,
        "66463": true,
        "66465": true,
        "66466": true,
        "66468": true,
        "66469": true,
        "66470": true,
        "66473": true,
        "66475": true,
        "66476": true,
        "66477": true,
        "66478": true,
        "66479": true,
        "66480": true,
        "66482": true,
        "66484": true,
        "66485": true,
        "66486": true,
        "66488": true,
        "66489": true,
        "66490": true,
        "66494": true,
        "66495": true,
        "66496": true,
        "66499": true
      },
      "San Pedro Garza García": {
        "66200": true,
        "66210": true,
        "66214": true,
        "66215": true,
        "66216": true,
        "66217": true,
        "66218": true,
        "66219": true,
        "66220": true,
        "66224": true,
        "66225": true,
        "66226": true,
        "66227": true,
        "66228": true,
        "66230": true,
        "66233": true,
        "66235": true,
        "66236": true,
        "66237": true,
        "66238": true,
        "66239": true,
        "66240": true,
        "66244": true,
        "66245": true,
        "66247": true,
        "66249": true,
        "66250": true,
        "66254": true,
        "66256": true,
        "66257": true,
        "66259": true,
        "66260": true,
        "66263": true,
        "66265": true,
        "66266": true,
        "66267": true,
        "66268": true,
        "66270": true,
        "66273": true,
        "66276": true,
        "66277": true,
        "66280": true,
        "66285": true,
        "66287": true,
        "66295": true,
        "66297": true
      },
      "Santa Catarina": {
        "66100": true,
        "66110": true,
        "66114": true,
        "66115": true,
        "66116": true,
        "66117": true,
        "66118": true,
        "66119": true,
        "66120": true,
        "66129": true,
        "66139": true,
        "66140": true,
        "66145": true,
        "66147": true,
        "66149": true,
        "66150": true,
        "66160": true,
        "66165": true,
        "66166": true,
        "66167": true,
        "66168": true,
        "66169": true,
        "66170": true,
        "66179": true,
        "66180": true,
        "66187": true,
        "66188": true,
        "66189": true,
        "66190": true,
        "66195": true,
        "66196": true,
        "66197": true,
        "66198": true,
        "66199": true,
        "66350": true,
        "66353": true,
        "66354": true,
        "66356": true,
        "66357": true,
        "66358": true,
        "66360": true,
        "66362": true,
        "66363": true,
        "66364": true,
        "66365": true,
        "66366": true,
        "66367": true,
        "66368": true,
        "66369": true,
        "66370": true,
        "66373": true,
        "66374": true,
        "66375": true,
        "66376": true,
        "66377": true,
        "66378": true
      }
    },
    "Puebla": {
      "Coronango": {
        "72670": true,
        "72680": true,
        "72683": true,
        "72685": true
      },
      "Cuautlancingo": {
        "72700": true,
        "72702": true,
        "72703": true,
        "72704": true,
        "72705": true,
        "72706": true,
        "72707": true,
        "72720": true,
        "72723": true,
        "72724": true,
        "72730": true,
        "72733": true,
        "72735": true
      },
      "Juan C. Bonilla": {
        "72640": true,
        "72669": true
      },
      "Puebla": {
        "72000": true,
        "72010": true,
        "72020": true,
        "72023": true,
        "72029": true,
        "72030": true,
        "72040": true,
        "72044": true,
        "72045": true,
        "72050": true,
        "72060": true,
        "72062": true,
        "72070": true,
        "72080": true,
        "72089": true,
        "72090": true,
        "72094": true,
        "72110": true,
        "72114": true,
        "72115": true,
        "72120": true,
        "72124": true,
        "72127": true,
        "72130": true,
        "72135": true,
        "72140": true,
        "72150": true,
        "72154": true,
        "72160": true,
        "72170": true,
        "72176": true,
        "72180": true,
        "72189": true,
        "72190": true,
        "72193": true,
        "72194": true,
        "72200": true,
        "72210": true,
        "72220": true,
        "72223": true,
        "72225": true,
        "72228": true,
        "72230": true,
        "72240": true,
        "72243": true,
        "72250": true,
        "72260": true,
        "72266": true,
        "72267": true,
        "72270": true,
        "72280": true,
        "72290": true,
        "72300": true,
        "72303": true,
        "72304": true,
        "72307": true,
        "72308": true,
        "72309": true,
        "72310": true,
        "72314": true,
        "72320": true,
        "72330": true,
        "72340": true,
        "72350": true,
        "72359": true,
        "72360": true,
        "72365": true,
        "72370": true,
        "72373": true,
        "72377": true,
        "72380": true,
        "72390": true,
        "72400": true,
        "72403": true,
        "72410": true,
        "72420": true,
        "72423": true,
        "72424": true,
        "72425": true,
        "72430": true,
        "72440": true,
        "72450": true,
        "72453": true,
        "72456": true,
        "72459": true,
        "72460": true,
        "72464": true,
        "72468": true,
        "72470": true,
        "72474": true,
        "72477": true,
        "72478": true,
        "72480": true,
        "72482": true,
        "72483": true,
        "72484": true,
        "72490": true,
        "72492": true,
        "72494": true,
        "72496": true,
        "72498": true,
        "72500": true,
        "72501": true,
        "72503": true,
        "72504": true,
        "72505": true,
        "72510": true,
        "72520": true,
        "72523": true,
        "72530": true,
        "72532": true,
        "72533": true,
        "72534": true,
        "72538": true,
        "72540": true,
        "72543": true,
        "72550": true,
        "72560": true,
        "72564": true,
        "72565": true,
        "72567": true,
        "72570": true,
        "72573": true,
        "72574": true,
        "72575": true,
        "72580": true,
        "72582": true,
        "72583": true,
        "72584": true,
        "72587": true,
        "72589": true,
        "72590": true,
        "72592": true,
        "72593": true,
        "72594": true
      },
      "San Andrés Cholula": {
        "72803": true,
        "72805": true,
        "72810": true,
        "72813": true,
        "72814": true,
        "72815": true,
        "72817": true,
        "72819": true,
        "72820": true,
        "72823": true,
        "72824": true,
        "72825": true,
        "72826": true,
        "72828": true,
        "72830": true,
        "72833": true,
        "72835": true,
        "72836": true,
        "72837": true,
        "72840": true,
        "72843": true,
        "72846": true
      },
      "San Pedro Cholula": {
        "72750": true,
        "72754": true,
        "72755": true,
        "72757": true,
        "72760": true,
        "72762": true,
        "72764": true,
        "72765": true,
        "72766": true,
        "72767": true,
        "72768": true,
        "72770": true,
        "72772": true,
        "72774": true,
        "72775": true,
        "72776": true,
        "72777": true,
        "72778": true
      }
    },
    "Querétaro": {
      "Corregidora": {
        "76900": true,
        "76902": true,
        "76903": true,
        "76904": true,
        "76905": true,
        "76906": true,
        "76907": true,
        "76908": true,
        "76910": true,
        "76912": true,
        "76930": true
      },
      "El Marqués": {
        "76240": true,
        "76244": true,
        "76246": true
      },
      "Querétaro": {
        "76000": true,
        "76010": true,
        "76017": true,
        "76020": true,
        "76024": true,
        "76025": true,
        "76026": true,
        "76027": true,
        "76028": true,
        "76030": true,
        "76036": true,
        "76037": true,
        "76040": true,
        "76046": true,
        "76047": true,
        "76048": true,
        "76049": true,
        "76050": true,
        "76057": true,
        "76058": true,
        "76059": true,
        "76060": true,
        "76063": true,
        "76067": true,
        "76069": true,
        "76070": true,
        "76074": true,
        "76078": true,
        "76079": true,
        "76080": true,
        "76085": true,
        "76086": true,
        "76087": true,
        "76090": true,
        "76093": true,
        "76099": true,
        "76100": true,
        "76110": true,
        "76113": true,
        "76114": true,
        "76115": true,
        "76116": true,
        "76117": true,
        "76118": true,
        "76120": true,
        "76121": true,
        "76125": true,
        "76127": true,
        "76130": true,
        "76134": true,
        "76135": true,
        "76136": true,
        "76137": true,
        "76138": true,
        "76139": true,
        "76140": true,
        "76144": true,
        "76146": true,
        "76147": true,
        "76148": true,
        "76149": true,
        "76150": true,
        "76154": true,
        "76155": true,
        "76156": true,
        "76157": true,
        "76158": true,
        "76159": true,
        "76160": true,
        "76164": true,
        "76165": true,
        "76166": true,
        "76168": true,
        "76169": true,
        "76170": true,
        "76175": true,
        "76176": true,
        "76177": true,
        "76178": true,
        "76179": true,
        "76180": true,
        "76185": true,
        "76190": true,
        "76197": true,
        "76199": true,
        "76226": true,
        "76230": true,
        "76235": true,
        "76238": true
      }
    },
    "San Luis Potosí": {
      "San Luis Potosí": {
        "78000": true,
        "78037": true,
        "78038": true,
        "78040": true,
        "78048": true,
        "78049": true,
        "78100": true,
        "78106": true,
        "78107": true,
        "78109": true,
        "78110": true,
        "78115": true,
        "78116": true,
        "78117": true,
        "78120": true,
        "78130": true,
        "78133": true,
        "78135": true,
        "78136": true,
        "78137": true,
        "78140": true,
        "78143": true,
        "78144": true,
        "78145": true,
        "78146": true,
        "78147": true,
        "78148": true,
        "78150": true,
        "78153": true,
        "78154": true,
        "78165": true,
        "78170": true,
        "78173": true,
        "78174": true,
        "78175": true,
        "78176": true,
        "78177": true,
        "78178": true,
        "78180": true,
        "78183": true,
        "78200": true,
        "78209": true,
        "78210": true,
        "78213": true,
        "78214": true,
        "78215": true,
        "78216": true,
        "78218": true,
        "78219": true,
        "78220": true,
        "78230": true,
        "78234": true,
        "78235": true,
        "78236": true,
        "78238": true,
        "78239": true,
        "78240": true,
        "78250": true,
        "78258": true,
        "78260": true,
        "78268": true,
        "78269": true,
        "78270": true,
        "78280": true,
        "78290": true,
        "78294": true,
        "78295": true,
        "78298": true,
        "78300": true,
        "78306": true,
        "78307": true,
        "78308": true,
        "78309": true,
        "78310": true,
        "78318": true,
        "78319": true,
        "78320": true,
        "78328": true,
        "78330": true,
        "78338": true,
        "78339": true,
        "78340": true,
        "78349": true,
        "78350": true,
        "78356": true,
        "78357": true,
        "78358": true,
        "78359": true,
        "78360": true,
        "78363": true,
        "78364": true,
        "78365": true,
        "78366": true,
        "78367": true,
        "78368": true,
        "78369": true,
        "78370": true,
        "78377": true,
        "78378": true,
        "78379": true,
        "78380": true,
        "78384": true,
        "78385": true,
        "78387": true,
        "78388": true,
        "78389": true,
        "78390": true,
        "78394": true,
        "78396": true,
        "78399": true
      },
      "Soledad de Graciano Sánchez": {
        "78430": true,
        "78432": true,
        "78433": true,
        "78434": true,
        "78435": true,
        "78436": true,
        "78437": true,
        "78438": true
      }
    }
  },
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();

      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onCityChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onCityChange();
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
    _CUSTOM_COD_FORM_PROVINCES.onCityChange();
  },
  onCityChange: function () {
    var provValue = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
  }
};


function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
  } catch (e) {
    console.log(e);
  }
  _CUSTOM_COD_FORM_PROVINCES.startFields();
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_ZIP_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province_country_field";
      item.backendFields.elementType = "select";

      var options = [];

      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).forEach(key => {
        options.push({
          label: key,
          value: key
        })
      })


      item.backendFields.options = options;
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    } else if (item.type == "zip_code") {
      item.type = "zip_country_field";
      item.backendFields.name = "zip_code";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_ZIP_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_ZIP_LABEL) {
        _COD_FORM_ZIP_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_ZIP_LABEL
      }];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}